import type { RoomsParticipantDistribution } from '@/domain/shared/types'
import type { SearchState } from '@/scopes/search/search/infrastructure/store/store'

export const VALID_SORT_OPTIONS = ['CustomersRating', 'Price', 'Popularity', 'DepartureDate', 'Priority3', 'Priority2']

export const POPULARITY_SORT_VARIANTS = new Set(['Popularity', 'Priority3', 'Priority2'])

export const POPULARITY_ALIASES = new Set(['Priority3', 'Priority2'])

export const SORT_OPTIONS: Record<string, { translation: string, subtext?: string }> = {
  Popularity: {
    translation: 'sort_option_popularity',
    subtext: 'sort_option_popularity_subtext',
  },
  Price: {
    translation: 'sort_option_price',
  },
  CustomersRating: {
    translation: 'sort_option_customer_rating',
  },
  DepartureDate: {
    translation: 'sort_option_departure_date',
  },
}

export function getDisplaySortingBy(sortingBy: string): string {
  return POPULARITY_ALIASES.has(sortingBy) ? 'Popularity' : sortingBy
}

export function getSortingAccordingToTestAndPartyComposition(
  searchState: Partial<SearchState>,
  enableSortingPersonalization: boolean,
): string {
  const sortingBy = searchState.sorting?.by ?? 'Popularity'

  if (!POPULARITY_SORT_VARIANTS.has(sortingBy)) {
    return sortingBy
  }

  if (!enableSortingPersonalization) {
    return 'Popularity'
  }

  const participants = searchState.filterSelection?.Participants as RoomsParticipantDistribution | undefined
  const hasChildrenOrBabies = participants?.some(room => room.children.length > 0 || room.babies.length > 0) ?? false

  return hasChildrenOrBabies ? 'Priority2' : 'Priority3'
}
